// On web, fall back to the standard Gluestack Menu so we keep keyboard
// navigation, hover states, focus management, and ARIA semantics. The
// press-and-slide gesture is a touch-first idiom that doesn't carry meaningful
// UX value on desktop.
export {
  Menu as SlideMenu,
  MenuItem as SlideMenuItem,
  MenuItemLabel as SlideMenuItemLabel,
  MenuSeparator as SlideMenuSeparator,
} from '@/components/gluestack/menu';

export type SlideMenuPlacement =
  | 'bottom left'
  | 'bottom right'
  | 'bottom'
  | 'top left'
  | 'top right'
  | 'top';
